import(/* webpackMode: "eager" */ "/srv/AltenB2B/node_modules/next/dist/client/link.js");
